




















































































































































import Vue from 'vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as ExchangeFuncs from '@/util-funcs/exchange-object-funcs';
import firebase from 'firebase/app';
import { format } from 'date-fns';

export default Vue.extend({
  props: {
    itemsToChargeFor: {
      type: Array,
      required: true,
    },
    forTablesidePostOrderPaymentThroughApp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickUpTimeOptions: [''],
      showDigitalWalletButton: false,
      userFormValid: false,
      cardElementInstance: null,
      stripeClient: null,
      paymentIntent: null,
      tipMultiplier: 0.15,
      otherTipMultiplier: null,
      generalRequests: '',
      isCardValid: false,
      referenceName: this.$store.state.referenceName,
      userFormFieldsToShow: [],
      fieldsToError: [],
      eAppModes: Enums.eAppModes,
      payOutsideOfApp: this.$store.state.appMode === Enums.eAppModes.tableside,
      readyForPayment: false,
    };
  },
  mounted() {
    this.onPageLoad();
  },
  watch: {
    toBeSentOrders(newVal, oldVal) {
      if (!(this.isTablesideMode && this.payOutsideOfApp)) {
        Vue.nextTick(() => {
          this.createPaymentIntent();
        });
      }
    },
    stripeAccount() {
      this.onPageLoad();
    },
    otherTipMultiplier() {
      this.setOthertip();
    },
    amount(newAmount) {
      if (newAmount > 50) {
        this.createPaymentIntent();
      }
    },
    currentClientUser() {
      this.createPaymentIntent();
    },
    requestedTime() {
      this.createPaymentIntent();
    },
    payOutsideOfApp(newVal) {
      if (newVal) {
        this.$data.tipMultiplier = 0;
      }
    },
    $route(to, from) {
      if (to.path.includes('/order') || to.path.includes('/bill-modal')) {
        this.onPageLoad();
      }
    },
  },
  computed: {
    showPaymentTypeSelection(): boolean {
      return this.canPayOutsideOfApp && this.canPayInsideOfApp;
    },
    tablesidePaymentsEnabled(): boolean {
      return Util.isFeatureEnabled(this.$store.state.featureFlags.tablsidePayments);
    },
    canPayOutsideOfApp(): boolean {
      if (this.$props.forTablesidePostOrderPaymentThroughApp) {
        return false;
      }
      switch (this.$store.state.appMode) {
        case Enums.eAppModes.tableside:
          return true;
          break;
        case Enums.eAppModes.takeout:
          return this.$store.state.currentLocation.enableOrderWithoutPayingForTakeout;
          break;
        case Enums.eAppModes.delivery:
          return this.$store.state.currentLocation.enableOrderWithoutPayingForDelivery;
          break;
      }
      return false;
    },
    canPayInsideOfApp(): boolean {
      switch (this.$store.state.appMode) {
        case Enums.eAppModes.tableside:
          return this.$store.state.currentLocation.enableOrderPrePayingForTableside && this.tablesidePaymentsEnabled;
          break;
        case Enums.eAppModes.takeout:
          return true;
          break;
        case Enums.eAppModes.delivery:
          return true;
          break;
      }
      return false;
    },
    isPayingOffline(): boolean {
      return this.$data.payOutsideOfApp;
    },
    requestedTime(): number {
      return this.$store.state.requestedTime;
    },
    isOutOfDeliveryRange(): boolean {
      return this.$store.state.isOutOfDeliveryRange;
    },
    isUnderMinimumOrderAmountForDelivery(): boolean {
      const minimumDeliveryOrderAmount = this.$store.state.currentLocation.minimumDeliveryOrderAmount;
      return this.$store.state.appMode === Enums.eAppModes.delivery && minimumDeliveryOrderAmount && this.amount <= minimumDeliveryOrderAmount;
    },
    showPayment(): boolean {
      return Boolean(this.stripeAccount && this.currentClientUser && this.$data.userFormValid);
    },
    showReferenceNameOption(): boolean {
      return !this.$store.state.referenceName;
    },
    isKioskMode(): boolean {
      return this.$store.state.isKioskMode;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    currentClientUser(): ClientUser {
      return this.$store.state.currentClientUser;
    },
    stripeAccount(): StripeAccount | null {
      return this.$store.state.currentSubscriptionData.stripeAccount;
    },
    deliveryChargeAmountPretax(): number {
      const currLocation: EstablishmentLocation = this.$store.state.currentLocation;
      return this.$store.state.appMode === Enums.eAppModes.delivery ? currLocation.deliveryChargeAmount : 0;
    },
    deliveryChargeAmount(): number {
      const currLocation: EstablishmentLocation = this.$store.state.currentLocation;
      return this.$store.state.appMode === Enums.eAppModes.delivery ? Math.round(Util.getPostTaxAmountForGenericCharge(currLocation.deliveryChargeAmount) || 0) : 0;
    },
    preTaxdeliveryChargeAmount(): number {
      const currLocation: EstablishmentLocation = this.$store.state.currentLocation;
      return this.$store.state.appMode === Enums.eAppModes.delivery ? currLocation.deliveryChargeAmount || 0 : 0;
    },
    preTaxAmountForOrder(): number {
      return Math.round(Util.getTotalForOrderItems(this.$props.itemsToChargeFor, 'preTax'));
    },
    postTaxAmountForOrder(): number {
      return Math.round(Util.getTotalForOrderItems(this.$props.itemsToChargeFor, 'postTax'));
    },
    tipAmount(): number {
      if (this.$data.payOutsideOfApp) {
        return 0;
      }
      return Math.round(this.preTaxAmountForOrder * this.$data.tipMultiplier);
    },
    amount(): number {
      const ret: number = Math.round(this.postTaxAmountForOrder + this.tipAmount + this.deliveryChargeAmount);
      return ret;
    },
    formattedTotalAmount(): string {
      return `<span class="bold">${Util.formatCurrency(this.amount)}</span>`;
    },
    getFormattedRequestTime(): string {
      return format(new Date(this.$store.state.requestedTime), 'MMM d, h:mma');
    },
    cannotOrder(): boolean {
      return this.$store.getters.cannotOrder;
    },
    toBeSentOrders(): OrderItem[] {
      return this.$store.state.toBeSentOrders;
    },
  },
  methods: {
    setOthertip() {
      let newVal: number = this.$data.otherTipMultiplier || 0;
      if (newVal > 100) {
        newVal = 100;
      } else if (!newVal || newVal < 0) {
        newVal = 0;
      }
      this.$data.tipMultiplier = newVal / 100;
    },
    getUpdateForExchangeDoc(paymentIntentId: string = '') {
      const orderInstanceId = Util.generateId();
      const wasPaidFor = Boolean(paymentIntentId);
      const orderItemsToSend = this.$props.itemsToChargeFor.map((oi: OrderItem) => {
        return {
          ...oi,
          paymentIntentId,
          orderInstanceId,
        };
      });

      const notificationCommonInfo: GenericOrderObjectNotification = {
        orderInstanceId,
        paymentIntentId,
        notificationId: Util.generateId(),
        type: Enums.eNotificationTypes.deliveryOrder, // To be changed below. Only included here for type correctness.
        orderItems: orderItemsToSend,
        amount: this.amount,
        tip: this.$data.tipMultiplier,
        status: Enums.eNotificationStatuses.pending,
        generalRequests: this.$data.generalRequests,
        dateCreated: Date.now(),
      };

      const GenericOrderObjectCommonInfo: AnyGenericOrderObject = {
        orderInstanceId,
        paymentIntentId,
        type: Enums.eOrderTypes.delivery, // To be changed below. Only included here for type correctness.
        preTaxAmountForOrder: this.preTaxAmountForOrder,
        postTaxAmountForOrder: this.postTaxAmountForOrder,
        amount: this.amount, // Total amount. Post tax amount + tip amount + post tax delivery charge.
        orderItems: orderItemsToSend,
        status: Enums.eOrderStatuses.pending,
        generalRequests: this.$data.generalRequests,
        dateCreated: Date.now(),
      };

      if (wasPaidFor) {
        GenericOrderObjectCommonInfo.tip = this.$data.tipMultiplier;
        GenericOrderObjectCommonInfo.tipAmount = this.tipAmount;
        GenericOrderObjectCommonInfo.preTaxDeliveryChargeAmount = this.preTaxdeliveryChargeAmount;
        GenericOrderObjectCommonInfo.postTaxDeliveryChargeAmount = this.deliveryChargeAmount;
      }

      let notification: GenericOrderObjectNotification | null = null;
      let GenericOrderObjectEntry: AnyGenericOrderObject | null = null;

      switch (this.$store.state.appMode) {
        case Enums.eAppModes.takeout:
          {
            const commonTakeoutData = {
              pickUpCode: Util.generateId()
                .slice(0, 4)
                .toUpperCase(),
              requestedTime: this.requestedTime,
            };
            notification = {
              ...notificationCommonInfo,
              ...commonTakeoutData,
              type: Enums.eNotificationTypes.takeoutOrder,
            } as PaidTakeoutOrderNotification;
            GenericOrderObjectEntry = {
              ...GenericOrderObjectCommonInfo,
              ...commonTakeoutData,
              type: Enums.eOrderTypes.takeout,
            } as TakeoutOrderObject;
          }
          break;
        case Enums.eAppModes.delivery:
          {
            const commonDeliveryData = {
              deliveryAddress: this.$store.state.currentDeliveryAddress,
              deliveryChargeAmount: this.deliveryChargeAmount,
              requestedTime: this.requestedTime,
            };
            notification = {
              ...notificationCommonInfo,
              ...commonDeliveryData,
              type: Enums.eNotificationTypes.deliveryOrder,
            } as PaidDeliveryOrderNotification;
            GenericOrderObjectEntry = {
              ...GenericOrderObjectCommonInfo,
              ...commonDeliveryData,
              type: Enums.eOrderTypes.delivery,
            } as DeliveryOrderObject;
          }
          break;
        case Enums.eAppModes.tableside:
          {
            notification = {
              ...notificationCommonInfo,
              type: this.$props.forTablesidePostOrderPaymentThroughApp ? Enums.eNotificationTypes.tablesidePostOrderPayment : Enums.eNotificationTypes.tablesideOrder,
            } as GenericOrderObjectNotification;
            GenericOrderObjectEntry = {
              ...GenericOrderObjectCommonInfo,
              type: Enums.eOrderTypes.tableside,
            } as GenericOrderObject;
          }
          break;
      }

      if (!notification || !GenericOrderObjectEntry) {
        Util.showError('Using an invalid ordering mode.');
      }

      const update: any = {
        notificationsToTheEstablishment: [...this.$store.state.currentUserEstablishmentExchangeObject.notificationsToTheEstablishment, notification],
      };

      let exchangeObjectGenericOrderObjectField = null;

      switch (this.$store.state.appMode) {
        case Enums.eAppModes.takeout:
          exchangeObjectGenericOrderObjectField = 'takeoutOrderCollection';
          break;
        case Enums.eAppModes.delivery:
          exchangeObjectGenericOrderObjectField = 'deliveryOrderCollection';
          break;
        case Enums.eAppModes.tableside:
          exchangeObjectGenericOrderObjectField = 'tablesideOrderCollection';
          break;
      }

      // If this already exists we have to update with dot notation, otherwise we just use regular keys.
      if (Util.userEstablishmentExchangeObjectExists()) {
        const updateEntryDotNotation = `${exchangeObjectGenericOrderObjectField}.${orderInstanceId}`;
        update[updateEntryDotNotation] = GenericOrderObjectEntry;
      } else {
        if (exchangeObjectGenericOrderObjectField) {
          update[exchangeObjectGenericOrderObjectField] = {
            [orderInstanceId]: GenericOrderObjectEntry,
          };
        } else {
          Util.showError('Tried to send a paid order for a non delivery/takeout/tableside order');
          return;
        }
      }
      return update;
    },
    sendOrder() {
      if (!this.userFormValid) {
        Util.showError('Form is invalid.');
        return;
      }

      Util.updateOrderTypeAvailabilities()
        .then(() => {
          const currentLocation: EstablishmentLocation = this.$store.state.currentLocation;
          if (this.$data.payOutsideOfApp) {
            if (this.requestedTime && this.requestedTime < Date.now()) {
                const errorString = Util.t?.cannotMakeAnOrderForAPastDate;
                Util.showError(errorString);
            } else {
              const update = this.getUpdateForExchangeDoc();
              ExchangeFuncs.updateExchangeObject(update, '', true).then(() => {
                Util.showNotice(Util.t?.orderSuccessfull);
              });
            }
          } else {
            // Paying online.
            if (this.$store.state.currentClientUser) {
              switch (this.$store.state.appMode) {
                case Enums.eAppModes.tableside:
                  if (!this.$store.state.tablesideAvailable) {
                    Util.showError(Util.t?.tablesideIsNoLongerAvailable);
                    return;
                  }
                  this.onCardPaymentSubmit();
                  break;
                case Enums.eAppModes.takeout:
                  if (!this.$store.state.takeoutAvailable && !currentLocation.orderAheadEnabled) {
                    Util.showError(Util.t?.takeoutIsNoLongerAvailable);
                    return;
                  }
                  this.onCardPaymentSubmit();
                  break;
                case Enums.eAppModes.delivery:
                  if (!this.$store.state.deliveryAvailable && !currentLocation.orderAheadEnabled) {
                    Util.showError(Util.t?.deliveryIsNoLongerAvailable);
                    return;
                  }
                  this.onCardPaymentSubmit();
                  break;
                default:
                  Util.showError('Unknown ordering mode.');
                  break;
              }
            } else {
              Util.showError(Util.t?.mustBeSignedIn);
            }
          }
        })
        .catch((error) => {
          if (this.isTablesideMode) {
            Util.showError(`Your order could not be sent. ${error}`);
          } else {
            Util.showError(`Something went wrong but you were not charged. ${error}`);
          }
        });
    },
    onPaymentReady() {
      this.$data.readyForPayment = true;
    },
    onPaymentNotReady() {
      this.$data.readyForPayment = false;
    },
    clearOrder() {
      Util.setToBeSentOrders([]);
    },
    getOrderingFromString(): string {
      return Util.getOrderingFromString();
    },
    formatCurrency(price: number): string {
      return Util.formatCurrency(price);
    },
    onFormInvalid() {
      this.$data.userFormValid = false;
      this.onPaymentNotReady();
    },
    onFormValid() {
      this.$data.userFormValid = true;
      this.createPaymentIntent();
    },
    onPageLoad() {
      if (this.stripeAccount) {
        this.$data.stripeClient = (window as any).Stripe(Util.getStripePublicKey(), {
          stripeAccount: this.stripeAccount.stripeUserId,
        });
      } else {
        Util.nonDebugLog('Stripe account not yet loaded.');
      }
      this.$data.generalRequests = '';
      this.createPaymentIntent();
    },
    setTip(tipMultiplier: number) {
      this.$data.tipMultiplier = tipMultiplier;
      this.createPaymentIntent();
    },
    createPaymentIntent() {
      this.$data.paymentIntent = null;

      // if (this.isTablesideMode) {
      //   return;
      // }

      // Keep this in a next tick so that any stripe neccesary UI hidden behind v-ifs have a chance to appear.
      Vue.nextTick(() => {
        // These errors would frequently occur and are expected. Should not display visible error messages.
        if (!this.currentClientUser) {
          Util.nonDebugLog('Must be signed in.');
          return;
        }

        if (!this.$props.itemsToChargeFor.length) {
          Util.nonDebugLog('No items to charge for.');
          return;
        }

        if (!this.$store.state.currentDeliveryAddress && this.$store.state.appMode === Enums.eAppModes.delivery) {
          Util.nonDebugLog('No delivery address provided for a delivery.');
          return;
        }

        if (!this.$store.state.contactNumber && this.$store.state.appMode !== Enums.eAppModes.tableside) {
          Util.nonDebugLog('No contact number provided for a delivery/takeout order.');
          return;
        }

        if (!this.$store.state.contactEmail) {
          Util.nonDebugLog('No contact email provided.');
          return;
        }

        if (!this.$store.state.referenceName) {
          Util.nonDebugLog('Must provide a reference name.');
          return;
        }

        if (this.amount <= 50) {
          const errorString = Util.t?.mustChargeAtLeast50;
          Util.showNotice(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        if (this.isUnderMinimumOrderAmountForDelivery) {
          const errorString = Util.t?.minimumDeliveryOrderAmount;
          Util.showNotice(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        if (this.isOutOfDeliveryRange) {
          const errorString = Util.t?.isOutOfDeliveryRange.supplant([this.$store.state.currentLocation.maximumDeliveryOrderDistance, this.$store.state.currentDistanceFromLocation]);
          Util.nonDebugLog(errorString);
          return;
        }

        if (this.cannotOrder) {
          let errorString = '';
          if (this.$store.state.currentLocation.orderAheadEnabled) {
            errorString = Util.t?.theLocationIsClosedAndNotOpenSoon.supplant([Util.t[this.$store.state.appMode]?.toLowerCase()]);
          } else {
            switch (this.$store.state.appMode) {
              case Enums.eAppModes.tableside:
                errorString = Util.t?.tablesideIsNotAvailable;
                break;
              case Enums.eAppModes.takeout:
                errorString = Util.t?.takeoutIsNotAvailable;
                break;
              case Enums.eAppModes.delivery:
                errorString = Util.t?.deliveryIsNotAvailable;
                break;
            }
          }
          Util.showError(errorString);
          Util.nonDebugLog('Cannot make an order right now.');
          return;
        }

        if (this.requestedTime && this.requestedTime < Date.now()) {
          const errorString = Util.t?.cannotMakeAnOrderForAPastDate;
          Util.showError(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        // These errors should never or rarely occur. They are the fault of the establishment, not the customer.
        if (!this.stripeAccount) {
          const errorString = 'This location must connect a stripe account to enable payments.';
          Util.showError(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        if (!this.$store.state.currentLocation.email) {
          const errorString = 'This location must provide a contact email to enable payments.';
          Util.showError(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        if (!this.$store.state.currentLocation.phoneNumber) {
          const errorString = 'This location must provide a contact number to enable payments.';
          Util.showError(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        let orderType: Enums.eNotificationTypes | null = null;

        switch (this.$store.state.appMode) {
          case Enums.eAppModes.delivery:
            orderType = Enums.eNotificationTypes.deliveryOrder;
            break;
          case Enums.eAppModes.takeout:
            orderType = Enums.eNotificationTypes.takeoutOrder;
            break;
          case Enums.eAppModes.tableside:
            orderType = Enums.eNotificationTypes.tablesideOrder;
            break;
        }

        if (!orderType) {
          const errorString = 'Invalid order type';
          Util.showNotice(errorString);
          Util.nonDebugLog(errorString);
          return;
        }

        const getPaymentIntentFunc = (): Promise<any> => {
          return new Promise((intentResolve: any, intentReject: any) => {
            let orderWasMadeDuringClosedHours = false;

            switch (this.$store.state.appMode) {
              case Enums.eAppModes.takeout:
                orderWasMadeDuringClosedHours = !Util.isRightTime(this.$store.state.currentLocation.takeoutTimeSlots, this.$store.state.currentLocation.utcOffset, Date.now());
                break;
              case Enums.eAppModes.delivery:
                orderWasMadeDuringClosedHours = !Util.isRightTime(this.$store.state.currentLocation.deliveryTimeSlots, this.$store.state.currentLocation.utcOffset, Date.now());
                break;
              case Enums.eAppModes.tableside:
                orderWasMadeDuringClosedHours = !Util.isRightTime(this.$store.state.currentLocation.tablesideTimeSlots, this.$store.state.currentLocation.utcOffset, Date.now());
                break;
            }

            Util.nonDebugLog('Creating new payment intent');

            Util.standardApiFetch(
              'tap-menu/create-intent',
              {
                referenceName: this.$store.state.referenceName || 'No Name',
                stripeUserId: (this.stripeAccount as StripeAccount).stripeUserId,
                establishmentName: this.$store.state.currentEstablishment.name,
                locationEmail: this.$store.state.currentLocation.email,
                locationPhoneNumber: this.$store.state.currentLocation.phoneNumber,
                locationAddress: this.$store.state.currentLocation.formattedAddress,
                locationDocPath: this.$store.state.currentLocationDoc.path,
                subscriptionDocPath: this.$store.state.currentSubscriptionDoc.path,
                itemsToChargeFor: this.$props.itemsToChargeFor,
                orderType,
                tip: this.$data.tipMultiplier,
                deliveryChargeAmount: this.deliveryChargeAmount,
                userId: this.$store.state.userId,
                userEmail: this.$store.state.contactEmail,
                userNumber: this.$store.state.contactNumber,
                locale: this.$store.state.locale,
                utcOffset: -1 * new Date().getTimezoneOffset(),
                sendEmailForOpenHours: Boolean(this.$store.state.currentLocation.receiveEmailsForOpenHoursTakeoutAndDeliveryOrders && !orderWasMadeDuringClosedHours),
                sendEmailForClosedHours: Boolean(this.$store.state.currentLocation.receiveEmailsForClosedHoursTakeoutAndDeliveryOrders && orderWasMadeDuringClosedHours),
                amount: this.amount,
              },
              (paymentIntent) => {
                intentResolve(paymentIntent);
              }
            );
          });
        };

        Util.showLoading();
        getPaymentIntentFunc().then((paymentIntent) => {
          if (!this.$data.stripeClient) {
            Util.nonDebugLog('Stripe client not yet initialized');
            Util.hideLoading();
            return;
          }
          this.$data.paymentIntent = paymentIntent;
          const elements = this.$data.stripeClient.elements();

          // SETTING UP DIGITAL WALLET BUTTON
          if (!this.isKioskMode) {
            const paymentRequest = this.$data.stripeClient.paymentRequest({
              country: 'CA',
              currency: 'cad',
              total: {
                label: `Purchase from ${this.$store.state.currentEstablishment.name}`,
                amount: this.amount,
              },
              requestPayerName: true,
              requestPayerEmail: true,
            });

            const prButton = elements.create('paymentRequestButton', {
              paymentRequest,
            });

            const onCanMakePaymentResultFailure = () => {
              this.$data.showDigitalWalletButton = false;
              const paymentButton = (document as any).getElementById('payment-request-button');
              if (paymentButton) {
                paymentButton.style.display = 'none';
              }
            };

            paymentRequest
              .canMakePayment()
              .then((result: any) => {
                if (result) {
                  const paymenyRequestElement = document.getElementById('payment-request-button');
                  if (paymenyRequestElement) {
                    paymenyRequestElement.innerHTML = '';
                    prButton.mount('#payment-request-button');
                  } else {
                    Util.nonDebugLog('No element to mount the payment request button to.');
                  }
                  this.$data.showDigitalWalletButton = true;
                } else {
                  onCanMakePaymentResultFailure();
                }
              })
              .catch(() => {
                onCanMakePaymentResultFailure();
              });

            paymentRequest.on('paymentmethod', async (ev: any) => {
              // Confirm the PaymentIntent without handling potential next actions (yet).

              if (!this.$data.paymentIntent) {
                Util.showError('Payment intent was not yet created.');
                this.$data.isCardValid = false;
                return;
              }

              const confirmCardPaymentPromise = this.$data.stripeClient.confirmCardPayment(paymentIntent.client_secret, { payment_method: ev.paymentMethod.id }, { handleActions: false });
              this.onPaymentSubmit(true, confirmCardPaymentPromise, ev);
            });
          }

          // SETTING UP THE CREDIT CARD ENTRY OPTION.
          // Custom styling can be passed to options when creating an Element.
          // (Note that this demo uses a wider set of styles than the guide below.)
          const stripeStyles = this.$store.state.stripeStyles;

          const style = {
            base: {
              fontFamily: `${stripeStyles.primaryFontName}, Helvetica, Arial, sans-serif`,
              color: '#000000',
              iconColor: '#000000',
              // color: stripeStyles.fontColorOnPrimaryRGBA,
              // iconColor: stripeStyles.fontColorOnPrimaryRGBA,
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#000000',
                // color: stripeStyles.fontColorOnPrimaryRGBA,
              },
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a',
            },
          };

          // Create an instance of the card Element.
          this.$data.cardElementInstance = elements.create('card', { style });

          // Add an instance of the card Element into the `card-element` <div>.
          const cardElementElement = document.getElementById('card-element');
          if (cardElementElement) {
            cardElementElement.innerHTML = '';
            this.$data.cardElementInstance.mount('#card-element');
          } else {
            Util.nonDebugLog('No element to mount the card element button to.');
          }

          const checkForCardInputError = (event: any) => {
            if (event.complete) {
              this.$data.isCardValid = true;
            } else if (event.error) {
              Util.showError(event.error.message);
              this.$data.isCardValid = false;
            } else {
              this.$data.isCardValid = false;
            }
          };

          // Handle real-time validation erors from the card Element.
          this.$data.cardElementInstance.addEventListener('change', checkForCardInputError);
          this.$data.isCardValid = false;
          this.onPaymentReady();
        });
      });
    },
    onCardPaymentSubmit() {
      if (!this.$data.stripeClient) {
        Util.showError('Stripe not yet initialized');
        return;
      }

      if (!this.$data.paymentIntent) {
        Util.showError('Payment intent was not yet created.');
        this.$data.isCardValid = false;
        return;
      }

      const confirmCardPaymentPromise = this.$data.stripeClient.confirmCardPayment(this.$data.paymentIntent.client_secret, {
        payment_method: {
          card: this.$data.cardElementInstance,
        },
      });
      this.onPaymentSubmit(false, confirmCardPaymentPromise, null);
    },
    onPaymentSubmit(paidViaDigitalWallet = false, confirmCardPaymentPromise: Promise<any>, ev: any) {
      this.$data.fieldsToError = [];

      if (!this.$data.paymentIntent) {
        Util.showError('Payment intent was not yet created.');
        this.$data.isCardValid = false;
        return;
      }

      if (this.$data.paymentIntent.errorMessage) {
        Util.showError(Util.t?.paymentIntentError);
        this.$data.isCardValid = false;
        return;
      }

      if (!paidViaDigitalWallet && !this.isCardValid) {
        Util.showError(Util.t?.invalidCCInfo);
        return;
      }

      const antiUpdate: any = { ...this.$store.state.currentUserEstablishmentExchangeObject };

      const onSuccess = (result: any) => {
        if (result.paymentIntent.status === 'requires_capture') {
          // Show a success message to your customer
          // TODO: There's a risk of the customer closing the window before callback
          // execution. Set up a webhook or plugin to listen for the
          // payment_intent.succeeded event that handles any business critical
          // post-payment actions.
          Util.setToBeSentOrders([]);
          if (this.isKioskMode) {
            Util.signOut();
          } else {
            Util.hideLoading();
            Util.showSuccess(Util.t?.paymentAuthorized);
          }
        } else {
          Util.hideLoading();
          Util.nonDebugLog('Non capture payment result happened: ', result.paymentIntent);
        }
      };

      const onFailure = (result: any) => {
        // Show error to your customer (e.g., insufficient funds)
        Util.hideLoading();
        // Change the update object back to how it was
        ExchangeFuncs.updateExchangeObject(antiUpdate).catch(() => {
          Util.showError(`Could not undo the changes made to the exchange doc prior to the failed payment.`);
        });
        Util.showError(`${Util.t?.paymentFailed} ${result.error.message}`);
      };

      const update = this.getUpdateForExchangeDoc(this.$data.paymentIntent.id);

      ExchangeFuncs.updateExchangeObject(update, '', true).then(() => {
        Util.showNotice(Util.t?.sendingPayment);
        Util.showLoading();
        // Actually send the payment.
        confirmCardPaymentPromise
          .then((result: any) => {
            if (paidViaDigitalWallet) {
              const { error: confirmError } = result;
              if (confirmError) {
                // Report to the browser that the payment failed, prompting it to
                // re-show the payment interface, or show an error message and close
                // the payment interface.
                ev.complete('fail');
                // Util.showError(`${Util.t?.digitalWalletPaymentFailed}: ${confirmError}`);
                onFailure(result);
              } else {
                // Report to the browser that the confirmation was successful, prompting
                // it to close the browser payment method collection interface.
                ev.complete('success');
                onSuccess(result);
                // Let Stripe.js handle the rest of the payment flow.
              }
            } else {
              if (result.error) {
                onFailure(result);
              } else {
                // The payment has been processed!
                onSuccess(result);
              }
            }
          })
          .catch((error: any) => {
            Util.hideLoading();
            Util.showError(`Could not confirm card payment: ${error?.message}`);
          });
      });
    },
  },
});
